const steps = [
  { no: "01", icon: "ri-bookmark-2-line", title: "收藏本导航页", desc: "把「吃瓜17 导航入口」加入浏览器收藏，日后从收藏夹一键找回，不用再搜索。" },
  { no: "02", icon: "ri-cursor-line", title: "挑选对应入口", desc: "按状态挑主站或备用通道，点击「进入」直达吃瓜17 网址地址，走不了就切换备用。" },
  { no: "03", icon: "ri-archive-line", title: "把常用网址归档", desc: "在地址收藏夹里存下常用链接，更新动态会提示入口变动，随时保持列表新鲜。" },
];

const tips = [
  "入口偶尔变动属正常，先走主站，不稳定再切备用 A / B。",
  "想第一时间知道入口与内容更新，可常回来刷新「更新动态」。",
  "把多个备用地址都收进收藏夹，等于给访问上了双保险。",
  "若在浏览器地址栏直接输入，认准本文档展示的最新吃瓜17网址地址即可。",
];

export default function Guide() {
  return (
    <section id="guide" className="bg-secondary-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold tracking-widest text-accent-700">· 使用帮助</span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">三步用好这个入口导航</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            不需要技术背景，照下面的顺序操作，就能稳定、快速地直达吃瓜17 主页入口。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 lg:grid-cols-3 gap-4">
          {steps.map((s) => (
            <article key={s.no} className="rounded-xl border border-secondary-200/70 bg-background-50 p-6">
              <div className="flex items-center justify-between">
                <span className="grid place-items-center w-11 h-11 rounded-lg bg-primary-500 text-background-50">
                  <i className={`${s.icon} text-xl`} />
                </span>
                <span className="font-heading text-4xl font-black text-secondary-200">{s.no}</span>
              </div>
              <h3 className="mt-4 text-base md:text-lg font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3 rounded-xl border border-secondary-200/70 bg-background-50 p-5 md:p-6">
          {tips.map((t) => (
            <div key={t} className="flex items-start gap-2.5 text-sm text-foreground-700 leading-relaxed">
              <i className="ri-checkbox-circle-line text-lg text-accent-600 shrink-0 mt-0.5" />
              {t}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}